export default function OperationalFrameworkSection() {
  const phases = [
    {
      number: '01',
      title: 'Pre-Manufacturing Phase',
      description: 'Review of manufacturing drawings, welding procedures, material specifications, and quality plans. Verification of supplier qualifications and sub-tier documentation.',
    },
    {
      number: '02',
      title: 'Manufacturing Phase',
      description: 'On-site surveillance at fabrication facilities. Witness of critical operations, testing activities, and inspection points. Real-time documentation of findings and non-conformances.',
    },
    {
      number: '03',
      title: 'Documentation Phase',
      description: 'Compilation of inspection records, test reports, material certifications, and traceability documentation. Final documentation package formatted per client requirements.',
    },
  ];

  return (
    <section className="py-28 px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-light-section border border-light-border rounded-full mb-6">
            <span className="text-industrial-steel text-xs font-medium tracking-[0.12em] uppercase">
              Operational Framework
            </span>
          </div>
          <h2 className="font-serif text-dark-primary text-4xl leading-tight mb-6">
            Service Delivery Process
          </h2>
          <p className="text-industrial-steel text-base leading-[1.8] max-w-3xl">
            Services are delivered through inspection and test plans developed in coordination with client quality requirements. Surveillance activities occur at defined hold points and witness points during manufacturing. Reporting is provided in formats compatible with client documentation systems and quality management frameworks where applicable.
          </p>
        </div>

        {/* Process Steps */}
        <div className="space-y-6">
          {phases.map((phase) => (
            <div key={phase.number} className="flex gap-8 bg-light-section border border-light-border rounded-lg p-8">
              <div className="flex-shrink-0">
                <span className="text-industrial-muted text-sm font-medium tracking-wider">
                  {phase.number}
                </span>
              </div>
              <div className="flex-1">
                <h3 className="text-dark-primary text-lg font-semibold mb-3 leading-snug">
                  {phase.title}
                </h3>
                <p className="text-industrial-steel text-sm leading-[1.75]">
                  {phase.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}